<template>
  <div class="pb-3" >
    <va-card :title="$t(`transmissions.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12">
              <div v-if='oldThumbnail.length > 0' class="form-group mt-3">
                <img
                  :src="$store.getters['environment/cdn'] + '/thumbnail/' + oldThumbnail"
                  style="height: 30vh; max-width: 100%;"
                >
              </div>
              <ValidationProvider name="Logo" :rules="oldThumbnail.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('transmissions.forms.thumbnailLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="thumbnail"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" name="URL" v-slot="{ errors }">
                <va-input
                  v-model="transmission.url"
                  :label="$t('transmissions.forms.urlLabel')"
                  :placeholder="$t('transmissions.forms.urlPlaceholder')"
                  :success="errors.length == 0 && transmission.url.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Título" v-slot="{ errors }">
                <va-input
                  v-model="transmission.title"
                  :label="$t('transmissions.forms.titleLabel')"
                  :placeholder="$t('transmissions.forms.titlePlaceholder')"
                  :success="errors.length == 0 && transmission.title.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Descrição" v-slot="{ errors }">
                <va-input
                  v-model="transmission.description"
                  :label="$t('transmissions.forms.descriptionLabel')"
                  :placeholder="$t('transmissions.forms.descriptionPlaceholder')"
                  :success="errors.length == 0 && transmission.description.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <label>{{$t('transmissions.forms.isActivePlaceholder')}}</label>
              <va-toggle
                v-model="transmission.is_active"
                small
                :label="transmission.is_active ? 'Sim' : 'Não'"
              />
              <label>{{$t('transmissions.forms.isPrivatePlaceholder')}}</label>
              <va-toggle
                v-model="transmission.is_private"
                small
                :label="transmission.is_private ? 'Sim' : 'Não'"
              />
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ErrorMessages from '../utils/ErrorMessages'
export default {
  name: 'TransmissionsAddUpdate',
  components: {
    ErrorMessages,
  },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      transmission: {
        url: '',
        title: '',
        description: '',
        thumbnail: '',
        is_active: false,
        is_private: false,
      },
      oldThumbnail: '',
      thumbnail: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  mounted () {
    this.transmission.url = ''
    this.transmission.title = ''
    this.transmission.description = ''
    this.transmission.thumbnail = ''
    if (this.updateData !== null) {
      this.transmission_get(this.updateData)
    }
  },
  watch: {
    thumbnail (value) {
      if (value.length > 0) {
        this.transmission.thumbnail = value[0].name
      }
    },
    updateData (value) {
      if (this.updateData !== null) {
        this.transmission_get(this.updateData)
      } else {
        this.transmission.url = ''
        this.transmission.thumbnail = ''
        this.transmission.title = ''
        this.transmission.description = ''
        this.transmission.is_active = false
        this.transmission.is_private = false
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    transmission_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value === 'thumbnail') {
          this.oldThumbnail = data[value]
          this.transmission[value] = ''
        } else if (value !== '__typename') {
          this.transmission[value] = data[value]
        }
      })
    },

    upload () {
      if (this.transmission.thumbnail.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.thumbnail[0])
        formData.append('path', 'thumbnail')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldThumbnail)
        }
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.transmission.thumbnail = resp.data.filename
          this.onSubmit()
        })
      } else {
        this.transmission.thumbnail = this.oldThumbnail
        this.onSubmit()
      }
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { url, title, description, thumbnail } = this.transmission
      const isActive = this.transmission.is_active
      const isPrivate = this.transmission.is_private
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($url: String!, $title: String!, $description: String!, $id: Int!, $is_active: Boolean!, $is_private: Boolean!, $thumbnail: String!) {
                  update_transmission_by_pk(pk_columns: {id: $id}, _set: {url: $url, title: $title, description: $description, is_active: $is_active, is_private: $is_private, thumbnail: $thumbnail}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($url: String, $title: String!, $description: String!, $is_active: Boolean!, $is_private: Boolean!, $thumbnail: String!) {
                  insert_transmission(objects: {url: $url, title: $title, description: $description, is_active: $is_active, is_private: $is_private, thumbnail: $thumbnail}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            url,
            is_active: isActive,
            is_private: isPrivate,
            title,
            description,
            thumbnail,
            id: this.transmission.id,
          } : {
            url,
            thumbnail,
            title,
            description,
            is_active: isActive,
            is_private: isPrivate,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.transmission.url = ''
          self.transmission.title = ''
          self.transmission.description = ''
          self.transmission.thumbnail = ''
          self.transmission.is_active = false
          self.transmission.is_private = false
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.transmission.url = ''
          self.transmission.title = ''
          self.transmission.description = ''
          self.transmission.thumbnail = ''
          self.tranisActivesmission.is_active = false
          self.transmission.is_private = false
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
